import { render } from "./configuration-cms.vue?vue&type=template&id=0a469d50"
import script from "./configuration-cms.vue?vue&type=script&lang=js"
export * from "./configuration-cms.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__